import { render, staticRenderFns } from "./PersonalView.vue?vue&type=template&id=4852d9fe&scoped=true"
import script from "./PersonalView.vue?vue&type=script&lang=js"
export * from "./PersonalView.vue?vue&type=script&lang=js"
import style0 from "./PersonalView.vue?vue&type=style&index=0&id=4852d9fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4852d9fe",
  null
  
)

export default component.exports